import { merge } from 'lodash/fp';
import { useQuery } from '@apollo/client/react';

import { VALIDATE_REFERRAL_CODE_QUERY } from './query.gql';
import client from '../../../../../graphql/client';

const useGetIsReferralCodeValid = (referralCode: string | undefined, opts = {}) => {
  const response = useQuery(
    VALIDATE_REFERRAL_CODE_QUERY,
    // @ts-expect-error - Automatic, Please fix when editing this file
    merge(
      {
        client,
        fetchPolicy: 'no-cache', // Without this the hook gets stuck loading true https://github.com/apollographql/react-apollo/issues/3361
        skip: !referralCode,
        variables: { referralCode },
      },
      opts,
    ),
  );

  const { loading, data } = response;

  return {
    isReferralCodeValid: data?.validateReferralCode?.isValid ?? false,
    loading,
  };
};

export default useGetIsReferralCodeValid;
